export default "__VITE_ASSET__B75UvNw4__"